'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var drain = require('it-drain');

var pushable = require('it-pushable');

var key = require('interface-datastore/key');

var cid = require('multiformats/cid');

var raw = require('multiformats/codecs/raw');

var Digest = require('multiformats/hashes/digest');

var base32 = require('multiformats/bases/base32');

var base58 = require('multiformats/bases/base58');

var errcode = require('err-code');

var base = require('blockstore-core/base');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

var pushable__default = /*#__PURE__*/_interopDefaultLegacy(pushable);

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

var Digest__namespace = /*#__PURE__*/_interopNamespace(Digest);

var errcode__default = /*#__PURE__*/_interopDefaultLegacy(errcode);

function cidToKey(cid$1) {
  var c = cid.CID.asCID(cid$1);

  if (!c) {
    throw errcode__default['default'](new Error('Not a valid cid'), 'ERR_INVALID_CID');
  }

  return new key.Key('/' + base32.base32.encode(c.multihash.bytes).slice(1).toUpperCase(), false);
}

function keyToCid(key) {
  return cid.CID.createV1(raw__namespace.code, Digest__namespace.decode(base32.base32.decode('b' + key.toString().slice(1).toLowerCase())));
}

function convertPrefix(prefix) {
  var firstChar = prefix.substring(0, 1);

  if (firstChar === '/') {
    return convertPrefix(prefix.substring(1));
  }

  var decoder;

  if (firstChar.toLowerCase() === 'b') {
    decoder = function decoder(input) {
      return base32.base32.decode(input.toLowerCase()).subarray(2);
    };
  } else if (firstChar.toLowerCase() === 'c') {
    decoder = function decoder(input) {
      return base32.base32pad.decode(input.toLowerCase()).subarray(2);
    };
  } else if (firstChar === 'z') {
    decoder = function decoder(input) {
      return base58.base58btc.decode(input).subarray(2);
    };
  } else if (firstChar === 'Q') {
    decoder = function decoder(input) {
      return base58.base58btc.decode('z' + input);
    };
  } else {
    decoder = function decoder(input) {
      return base32.base32.decode('b' + input.toLowerCase()).subarray(2);
    };
  }

  var bytes;

  for (var i = 1; i < prefix.length; i++) {
    try {
      bytes = decoder(prefix.substring(0, i));
    } catch (err) {
      if (err.message !== 'Unexpected end of data') {
        throw err;
      }
    }
  }

  var str = '/C';

  if (bytes) {
    str = "/".concat(base32.base32.encode(bytes).slice(1, -1).toUpperCase() || 'C');
  }

  return str;
}

function convertQuery(query) {
  return _objectSpread(_objectSpread({}, query), {}, {
    prefix: query.prefix ? convertPrefix(query.prefix) : undefined,
    filters: query.filters ? query.filters.map(function (filter) {
      return function (pair) {
        return filter({
          key: keyToCid(pair.key),
          value: pair.value
        });
      };
    }) : undefined,
    orders: query.orders ? query.orders.map(function (order) {
      return function (a, b) {
        return order({
          key: keyToCid(a.key),
          value: a.value
        }, {
          key: keyToCid(b.key),
          value: b.value
        });
      };
    }) : undefined
  });
}

function convertKeyQuery(query) {
  return _objectSpread(_objectSpread({}, query), {}, {
    prefix: query.prefix ? convertPrefix(query.prefix) : undefined,
    filters: query.filters ? query.filters.map(function (filter) {
      return function (key) {
        return filter(keyToCid(key));
      };
    }) : undefined,
    orders: query.orders ? query.orders.map(function (order) {
      return function (a, b) {
        return order(keyToCid(a), keyToCid(b));
      };
    }) : undefined
  });
}

var BlockstoreDatastoreAdapter = /*#__PURE__*/function (_base$BaseBlockstore) {
  _inherits(BlockstoreDatastoreAdapter, _base$BaseBlockstore);

  var _super = _createSuper(BlockstoreDatastoreAdapter);

  function BlockstoreDatastoreAdapter(datastore) {
    var _this5;

    _classCallCheck(this, BlockstoreDatastoreAdapter);

    _this5 = _super.call(this);
    _this5.child = datastore;
    return _this5;
  }

  _createClass(BlockstoreDatastoreAdapter, [{
    key: "open",
    value: function open() {
      return this.child.open();
    }
  }, {
    key: "close",
    value: function close() {
      return this.child.close();
    }
  }, {
    key: "query",
    value: function query(_query, options) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, _key, value;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 2;
                _iterator = _asyncIterator(_this.child.query(convertQuery(_query), options));

              case 4:
                _context.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 13;
                  break;
                }

                _step$value = _step.value, _key = _step$value.key, value = _step$value.value;
                _context.next = 10;
                return {
                  key: keyToCid(_key),
                  value: value
                };

              case 10:
                _iteratorAbruptCompletion = false;
                _context.next = 4;
                break;

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 19:
                _context.prev = 19;
                _context.prev = 20;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 24;
                return _awaitAsyncGenerator(_iterator.return());

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(19);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(query, options) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _key2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context2.prev = 2;
                _iterator2 = _asyncIterator(_this2.child.queryKeys(convertKeyQuery(query), options));

              case 4:
                _context2.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                  _context2.next = 13;
                  break;
                }

                _key2 = _step2.value;
                _context2.next = 10;
                return keyToCid(_key2);

              case 10:
                _iteratorAbruptCompletion2 = false;
                _context2.next = 4;
                break;

              case 13:
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return _awaitAsyncGenerator(_iterator2.return());

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError2) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(19);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid, options) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.child.get(cidToKey(cid), options));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getMany",
    value: function getMany(cids, options) {
      var _this3 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _cid;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorAbruptCompletion3 = false;
                _didIteratorError3 = false;
                _context4.prev = 2;
                _iterator3 = _asyncIterator(cids);

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator3.next());

              case 6:
                if (!(_iteratorAbruptCompletion3 = !(_step3 = _context4.sent).done)) {
                  _context4.next = 13;
                  break;
                }

                _cid = _step3.value;
                _context4.next = 10;
                return _this3.get(_cid, options);

              case 10:
                _iteratorAbruptCompletion3 = false;
                _context4.next = 4;
                break;

              case 13:
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 19:
                _context4.prev = 19;
                _context4.prev = 20;

                if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 24;
                return _awaitAsyncGenerator(_iterator3.return());

              case 24:
                _context4.prev = 24;

                if (!_didIteratorError3) {
                  _context4.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context4.finish(24);

              case 28:
                return _context4.finish(19);

              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    }
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid, value, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.child.put(cidToKey(cid), value, options);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function put(_x3, _x4, _x5) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "putMany",
    value: function putMany(blocks, options) {
      var _this4 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var output, runner;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                output = pushable__default['default']();
                runner = globalThis.process && globalThis.process.nextTick ? globalThis.process.nextTick : globalThis.setImmediate || globalThis.setTimeout;
                runner( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                  var store;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.prev = 0;
                          store = _this4.child;
                          _context7.next = 4;
                          return drain__default['default'](_this4.child.putMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                            var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, block, _key3, exists;

                            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                              while (1) {
                                switch (_context6.prev = _context6.next) {
                                  case 0:
                                    _iteratorAbruptCompletion4 = false;
                                    _didIteratorError4 = false;
                                    _context6.prev = 2;
                                    _iterator4 = _asyncIterator(blocks);

                                  case 4:
                                    _context6.next = 6;
                                    return _awaitAsyncGenerator(_iterator4.next());

                                  case 6:
                                    if (!(_iteratorAbruptCompletion4 = !(_step4 = _context6.sent).done)) {
                                      _context6.next = 19;
                                      break;
                                    }

                                    block = _step4.value;
                                    _key3 = cidToKey(block.key);
                                    _context6.next = 11;
                                    return _awaitAsyncGenerator(store.has(_key3, options));

                                  case 11:
                                    exists = _context6.sent;

                                    if (exists) {
                                      _context6.next = 15;
                                      break;
                                    }

                                    _context6.next = 15;
                                    return {
                                      key: _key3,
                                      value: block.value
                                    };

                                  case 15:
                                    output.push(block);

                                  case 16:
                                    _iteratorAbruptCompletion4 = false;
                                    _context6.next = 4;
                                    break;

                                  case 19:
                                    _context6.next = 25;
                                    break;

                                  case 21:
                                    _context6.prev = 21;
                                    _context6.t0 = _context6["catch"](2);
                                    _didIteratorError4 = true;
                                    _iteratorError4 = _context6.t0;

                                  case 25:
                                    _context6.prev = 25;
                                    _context6.prev = 26;

                                    if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                                      _context6.next = 30;
                                      break;
                                    }

                                    _context6.next = 30;
                                    return _awaitAsyncGenerator(_iterator4.return());

                                  case 30:
                                    _context6.prev = 30;

                                    if (!_didIteratorError4) {
                                      _context6.next = 33;
                                      break;
                                    }

                                    throw _iteratorError4;

                                  case 33:
                                    return _context6.finish(30);

                                  case 34:
                                    return _context6.finish(25);

                                  case 35:
                                  case "end":
                                    return _context6.stop();
                                }
                              }
                            }, _callee6, null, [[2, 21, 25, 35], [26,, 30, 34]]);
                          }))()));

                        case 4:
                          output.end();
                          _context7.next = 10;
                          break;

                        case 7:
                          _context7.prev = 7;
                          _context7.t0 = _context7["catch"](0);
                          output.end(_context7.t0);

                        case 10:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, null, [[0, 7]]);
                })));
                return _context8.delegateYield(_asyncGeneratorDelegate(_asyncIterator(output), _awaitAsyncGenerator), "t0", 4);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }, {
    key: "has",
    value: function has(cid, options) {
      return this.child.has(cidToKey(cid), options);
    }
  }, {
    key: "delete",
    value: function _delete(cid, options) {
      return this.child.delete(cidToKey(cid), options);
    }
  }, {
    key: "deleteMany",
    value: function deleteMany(cids, options) {
      var out = pushable__default['default']();
      drain__default['default'](this.child.deleteMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _cid2;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _iteratorAbruptCompletion5 = false;
                _didIteratorError5 = false;
                _context9.prev = 2;
                _iterator5 = _asyncIterator(cids);

              case 4:
                _context9.next = 6;
                return _awaitAsyncGenerator(_iterator5.next());

              case 6:
                if (!(_iteratorAbruptCompletion5 = !(_step5 = _context9.sent).done)) {
                  _context9.next = 14;
                  break;
                }

                _cid2 = _step5.value;
                _context9.next = 10;
                return cidToKey(_cid2);

              case 10:
                out.push(_cid2);

              case 11:
                _iteratorAbruptCompletion5 = false;
                _context9.next = 4;
                break;

              case 14:
                _context9.next = 20;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9["catch"](2);
                _didIteratorError5 = true;
                _iteratorError5 = _context9.t0;

              case 20:
                _context9.prev = 20;
                _context9.prev = 21;

                if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
                  _context9.next = 25;
                  break;
                }

                _context9.next = 25;
                return _awaitAsyncGenerator(_iterator5.return());

              case 25:
                _context9.prev = 25;

                if (!_didIteratorError5) {
                  _context9.next = 28;
                  break;
                }

                throw _iteratorError5;

              case 28:
                return _context9.finish(25);

              case 29:
                return _context9.finish(20);

              case 30:
                out.end();

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[2, 16, 20, 30], [21,, 25, 29]]);
      }))(), options)).catch(function (err) {
        out.end(err);
      });
      return out;
    }
  }]);

  return BlockstoreDatastoreAdapter;
}(base.BaseBlockstore);

exports.BlockstoreDatastoreAdapter = BlockstoreDatastoreAdapter;